import { useStore } from '@/store'
import './timeStatus.scss'
import { CSSProperties, useEffect, useMemo, useRef, useState } from 'react'
import { useLocal } from '@/i18n/LocalContext'
import { timeZeroFill } from '@/utils'

export default function TimeStatus() {
  const { $t } = useLocal()
  const { state } = useStore()
  const timeout = useRef(-1)
  const serverTime = state.serverTime
  const [currentTime, setCurrentTime] = useState(0)
  const startTime = state.startTime
  const endTime = state.endTime
  const activityExist = currentTime > 0 && startTime > 0 && endTime > 0
  const hasGameover = activityExist && currentTime > endTime
  const hasGamestart = activityExist && currentTime >= startTime && !hasGameover
  const timeText = useMemo<string>(() => {
    // 活动已结束 后活动结束 活动未开始
    if (hasGameover) {
      return $t('活动已结束')
    }
    if (!hasGamestart) {
      return $t('活动未开始')
    }

    let day = 0
    let hour = 0
    let M = 0
    let S = 0
    let statusText = $t('{t}后活动结束')
    let time = endTime - currentTime
    day = Math.floor(time / 86400)
    hour = Math.floor((time % 86400) / 3600)
    M = Math.floor((time % 3600) / 60)
    S = time % 60
    return statusText.replace(
      '{t}',
      `<span>${timeZeroFill(day)}</span>D<span>${timeZeroFill(
        hour
      )}</span>H<span>${timeZeroFill(M)}</span>M<span>${timeZeroFill(
        S
      )}</span>S&nbsp;`
    )
  }, [currentTime, startTime, endTime])
  const style = useMemo<CSSProperties>(() => {
    if (!activityExist)
      return {
        opacity: '0',
      }

    return {}
  }, [activityExist])

  useEffect(() => {
    const cb = () => {
      clearTimeout(timeout.current)
    }

    if (serverTime <= 0) return cb

    if (currentTime >= endTime) return cb

    timeout.current = window.setTimeout(() => {
      setCurrentTime((prevTime) => {
        if (prevTime === 0) return serverTime
        return prevTime + 1
      })
    }, 1000)

    return cb
  }, [serverTime, endTime, currentTime])

  return (
    <div className="time-status" style={style}>
      <div className="bg"></div>
      <div className="text">
        <i dangerouslySetInnerHTML={{ __html: timeText }}></i>
      </div>
    </div>
  )
}
